<template>
  <div id="cardContentRayonX">
    <div class="cardContentRayonX_title">
      SOON
    </div>
    <!-- <div class="mt-3">
      Votre diagnostique sectoriel
    </div>
    <div class="mt-3">
      Vous faites mieux que 56% de nos utilisateurs
      <img src="./étoiles.png" alt="cardContentrayonXetoiles" />
    </div>
    <div class="mt-3">
      Diversification potentielle sur plusieurs secteurs
    </div>
    <div class="mt-3">
      <b-button class="btnCardContent">Analyser mon portefeuille par des experts</b-button>
    </div> -->
  </div>
</template>
<script>
export default {};
</script>
